import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import DateSocialShareBody from './DateSocialShareBody';

const View = (props) => <DateSocialShareBody {...props} />;

export default withBlockExtensions(View);
